export default __webpack_public_path__ + "static/media/select-radio-active-colored.87b7f3aa.svg";